import { useTranslations } from 'next-intl'
import Toaster from './Toaster/Toaster'

type ExportDataToasterProps = {
    isMutating: boolean
    onCancelExport: () => void
}

const ExportDataToaster = ({ isMutating, onCancelExport }: ExportDataToasterProps) => {
    const t = useTranslations('root')

    return (
        <Toaster
            data-testid="__export-data-toaster__"
            title={t('components.exportDialog.toaster.title')}
            description={t('components.exportDialog.toaster.description')}
            intent="info"
            isClosable={false}
            open={isMutating}
            action={{ label: t('components.exportDialog.toaster.cancel'), onClick: onCancelExport }}
        />
    )
}

export default ExportDataToaster
